// new list of banks extracted from doc: https://docs.cielo.com.br/split/reference/lista-de-c%C3%B3digos-de-compensa%C3%A7%C3%A3o
export const banksOptions = [
  { value: '001', label: 'Banco do Brasil' },
  { value: '003', label: 'Amazônia - BASA' },
  { value: '004', label: 'BNB' },
  { value: '012', label: 'BANCO INBURSA' },
  { value: '021', label: 'Est. ES - Banestes' },
  { value: '025', label: 'Alfa' },
  { value: '033', label: 'Santander' },
  { value: '037', label: 'Est. PA - Banpará' },
  { value: '041', label: 'Est. RS - Banrisul' },
  { value: '047', label: 'Est. SE - Banese' },
  { value: '063', label: 'BANCO BRADESCARD' },
  { value: '069', label: 'Banco Crefisa' },
  { value: '070', label: 'BRB - Banco de Brasília' },
  { value: '077', label: 'Banco Inter' },
  { value: '081', label: 'BANCOSEGURO S.A.' },
  { value: '082', label: 'Banco Topázio' },
  { value: '083', label: 'BCO DA CHINA BRASIL S.A.' },
  { value: '084', label: 'CC Uniprime Norte do Paraná' },
  { value: '085', label: 'CC Cecred' },
  { value: '089', label: 'CC Região da Mogiana' },
  { value: '093', label: 'POLOCRED SCMEPP LTDA.' },
  { value: '094', label: 'Banco Finaxis' },
  { value: '097', label: 'CC Centralcredi' },
  { value: '099', label: 'CC Uniprime Central' },
  { value: '102', label: 'XP INVESTIMENTOS CCTVM S/A' },
  { value: '104', label: 'Caixa Econômica Federal' },
  { value: '107', label: 'BBM' },
  { value: '120', label: 'Rodobens' },
  { value: '121', label: 'BCO AGIBANK S.A.' },
  { value: '125', label: 'BANCO GENIAL' },
  { value: '130', label: 'Scfi Caruana' },
  { value: '133', label: 'CRESOL CONFEDERAÇÃO' },
  { value: '136', label: 'CC Unicred do Brasil' },
  { value: '149', label: 'FACTA S.A. CFI' },
  { value: '174', label: 'PEFISA S.A. - C.F.I.' },
  { value: '195', label: 'VALOR SCD S.A.' },
  { value: '197', label: 'STONE PAGAMENTOS S.A' },
  { value: '208', label: 'BANCO BTG PACTUAL S.A' },
  { value: '212', label: 'Banco Original' },
  { value: '213', label: 'Arbi' },
  { value: '218', label: 'Banco BS2' },
  { value: '224', label: 'Fibra' },
  { value: '237', label: 'Bradesco' },
  { value: '243', label: 'Banco Master' },
  { value: '246', label: 'ABC - Brasil' },
  { value: '260', label: 'NU PAGAMENTOS S.A (NUBANK)' },
  { value: '274', label: 'Money Plus SCMEPP LTDA' },
  { value: '299', label: 'BCO SOROCRED S.A. - BM' },
  { value: '301', label: 'Bpp Instituição De Pagamentos S.A' },
  { value: '318', label: 'BCO BMG S.A.' },
  { value: '320', label: 'BCO CCB BRASIL S.A.' },
  { value: '323', label: 'Mercado Pago' },
  { value: '329', label: 'QI SCD S.A.' },
  { value: '330', label: 'BANCO BARI S.A.' },
  { value: '335', label: 'Banco Digio S.A.' },
  { value: '336', label: 'Banco C6 S.A' },
  { value: '341', label: 'Itaú Unibanco' },
  { value: '348', label: 'BCO XP S.A.' },
  { value: '359', label: 'ZEMA CFI S/A' },
  { value: '364', label: 'GERENCIANET' },
  { value: '368', label: 'BCO CSF S.A.' },
  { value: '376', label: 'J. P. Morgan' },
  { value: '380', label: 'PICPAY' },
  { value: '382', label: 'FIDUCIA SCMEPP LTDA' },
  { value: '383', label: 'JUNO' },
  { value: '389', label: 'Mercantil do Brasil' },
  { value: '394', label: 'BCO BRADESCO FINANC. S.A.' },
  { value: '396', label: 'HUB PAGAMENTOS' },
  { value: '403', label: 'CORA SCD S.A.' },
  { value: '404', label: 'SUMUP SCD S.A.' },
  { value: '406', label: 'ACCREDITO SCD S.A.' },
  { value: '413', label: 'BCO BV S.A.' },
  { value: '414', label: 'WORK SCD S.A.' },
  { value: '422', label: 'Safra' },
  { value: '435', label: 'DELCRED SCD S.A.' },
  { value: '450', label: 'FITBANK PAGAMENTOS ELETRONICOS S.A.' },
  { value: '477', label: 'CITIBANK N.A.' },
  { value: '487', label: 'DEUTSCHE BANK S.A.BCO ALEMAO' },
  { value: '542', label: 'Cloud Walk Meios de Pagamentos' },
  { value: '595', label: 'Zoop Instituição de Pagamentos' },
  { value: '600', label: 'Luso Brasileiro' },
  { value: '604', label: 'Indl. do Brasil' },
  { value: '611', label: 'Paulista' },
  { value: '612', label: 'Guanabara' },
  { value: '613', label: 'OMNI BANCO S.A.' },
  { value: '623', label: 'BANCO PAN' },
  { value: '630', label: 'Banco Smartbank' },
  { value: '633', label: 'Rendimento' },
  { value: '634', label: 'Triângulo' },
  { value: '637', label: 'Sofisa' },
  { value: '643', label: 'Pine' },
  { value: '653', label: 'BANCO VOITER' },
  { value: '654', label: 'Banco Digimais' },
  { value: '655', label: 'Votorantim' },
  { value: '707', label: 'Daycoval' },
  { value: '741', label: 'Ribeirão Preto' },
  { value: '743', label: 'Semear' },
  { value: '745', label: 'Citibank S. A.' },
  { value: '748', label: 'Sicredi' },
  { value: '752', label: 'BCO BNP PARIBAS BRASIL S A' },
  { value: '753', label: 'NOVO BCO CONTINENTAL S.A. - BM' },
  { value: '755', label: 'Bank of America Merrill Lynch' },
  { value: '756', label: 'Sicoob' },
  { value: '757', label: 'BCO KEB HANA DO BRASIL S.A.' }
]
